import { orderObjectStatus } from "./orderStatus";
import { ticketObjectStatus } from "./ticketStatus";

/**
 * Un color por estado, idéntico en tabla, chip y gráfico.
 * `text` / `bg` arman el chip; `dot` es el color pleno para barras y puntos.
 */
/**
 * Texto y fondo salen de variables CSS para que el chip funcione igual en claro
 * y en oscuro. El punto de color queda literal: es una mancha chica que se lee
 * bien sobre los dos fondos y así se mantiene igual en gráficos y exportaciones.
 */
const TONE = {
  warn: { text: "var(--sup-state-warn-ink)", bg: "var(--sup-state-warn-bg)" },
  ok: { text: "var(--sup-state-ok-ink)", bg: "var(--sup-state-ok-bg)" },
  info: { text: "var(--sup-state-info-ink)", bg: "var(--sup-state-info-bg)" },
  teal: { text: "var(--sup-state-teal-ink)", bg: "var(--sup-state-teal-bg)" },
  paid: { text: "var(--sup-state-paid-ink)", bg: "var(--sup-state-paid-bg)" },
  danger: { text: "var(--sup-state-danger-ink)", bg: "var(--sup-state-danger-bg)" },
  muted: { text: "var(--sup-state-muted-ink)", bg: "var(--sup-state-muted-bg)" },
};

export const orderStatusStyles = {
  [orderObjectStatus.pendiente]: { ...TONE.warn, dot: "#c8861a" },
  [orderObjectStatus.terminado]: { ...TONE.ok, dot: "#6fa32e" },
  [orderObjectStatus.listoParaFacturar]: { ...TONE.info, dot: "#6165c4" },
  [orderObjectStatus.facturada]: { ...TONE.teal, dot: "#23968a" },
  [orderObjectStatus.pagado]: { ...TONE.paid, dot: "#2f5e2a" },
  [orderObjectStatus.solicitudDeCancelación]: { ...TONE.danger, dot: "#e53935" },
  [orderObjectStatus.cancelado]: { ...TONE.muted, dot: "#a09b98" },
};

export const ticketStatusStyles = {
  [ticketObjectStatus.pendiente]: { ...TONE.warn, dot: "#c8861a" },
  [ticketObjectStatus.autorizada]: { ...TONE.info, dot: "#6165c4" },
  [ticketObjectStatus.pagada]: { ...TONE.paid, dot: "#2f5e2a" },
  [ticketObjectStatus.cancelada]: { ...TONE.muted, dot: "#a09b98" },
};

/** Estados de cheque de paymentDetails: 0 pendiente, 1 cobrado, 2 rechazado. */
export const checkStateStyles = {
  0: { ...TONE.warn, dot: "#c8861a", label: "Pendiente" },
  1: { ...TONE.ok, dot: "#6fa32e", label: "Cobrado" },
  2: { ...TONE.danger, dot: "#e53935", label: "Rechazado" },
};

const FALLBACK = { ...TONE.muted, dot: "#a09b98" };

export const getOrderStatusStyle = (value) => orderStatusStyles[value] || FALLBACK;
export const getTicketStatusStyle = (value) => ticketStatusStyles[value] || FALLBACK;
export const getCheckStateStyle = (value) => checkStateStyles[value] || FALLBACK;
